import styled from '@emotion/styled';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { MdxLink } from '../pages/shared/MdxLink';
import { TagBadgeWidget } from './TagBadgeWidget';

export interface AttributeReferenceWidgetProps {
  badge?: string;
  href: string;
  label: string;
  sinceVersion?: string;
  tone?: string;
}

export const AttributeReferenceWidget: React.FC<AttributeReferenceWidgetProps> = ({
  badge,
  href,
  label,
  sinceVersion,
  tone
}) => {
  return (
    <S.Root data-content-attribute-reference>
      <S.Link aria-label={`${label} shared attribute docs`} href={href} title={`${label} shared attribute docs`}>
        <S.LinkText>shared attribute docs</S.LinkText>
        {badge ? (
          <TagBadgeWidget sinceVersion={sinceVersion} tone={tone}>
            {badge}
          </TagBadgeWidget>
        ) : null}
        <S.Icon icon={faExternalLinkAlt} />
      </S.Link>
    </S.Root>
  );
};

namespace S {
  export const Root = styled.div`
    max-width: 460px;
  `;

  export const Link = styled(MdxLink)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    max-width: 100%;
    padding: 7px 10px;
    border: 1px solid ${(p) => p.theme.text.listBorder};
    border-radius: var(--content-list-radius);
    background: ${(p) => p.theme.text.tableBackground};
    color: ${(p) => p.theme.text.paragraph};
    line-height: 1.35;
    text-decoration: none;

    &:hover {
      transition:
        border-color 160ms ease,
        background 160ms ease,
        color 160ms ease;
      border-color: ${(p) => p.theme.text.special};
      background: ${(p) => p.theme.card.hoverBackground};
      color: ${(p) => p.theme.text.heading};
    }

    &,
    &:hover,
    &:focus,
    &:active {
      text-decoration: none !important;
    }
  `;

  export const LinkText = styled.span`
    min-width: 0;
    font-size: 13px;
    font-style: italic;
    font-weight: 500;
    overflow-wrap: anywhere;
  `;

  export const Icon = styled(FontAwesomeIcon)`
    flex: 0 0 auto;
    width: 11px;
    height: 11px;
    opacity: 0.72;
  `;
}
